import styled from 'styled-components'

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  overflow: hidden;

  padding: 16px 25px;

  width: 100%;
  height: 100%;
  max-height: 137px;

  pointer-events: none;
`

export const Field = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 137px;

  @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
    label {
      max-width: 200px;
    }
  }

  & > * {
    height: 100%;
    width: 100%;

    &::-webkit-scrollbar {
      display: none;
    }

    scrollbar-width: none;
    -ms-overflow-style: none;
  }
`

export const FakeContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
`
